class Product {
  constructor() {
    this.acc = [];
    this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner");
    this.container = document.querySelector(".m-main-product");
    MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
    MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();
    this.loadRebuyAddonsFunct();
    //this.addEventRebuyAddOns();

    addEventDelegate({
      context: this.container,
      selector: (window.__minimog_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
      const index = e.target.closest('.m-product-collapsible').dataset.index
      setTimeout(() => {
        this.acc[Number(index)].setContentHeight()
      }, 300)},
      capture: true
    })
  }

  addRecentViewedProduct() {
    const cookies = getCookie('m-recent-viewed-products')
    let products = cookies ? JSON.parse(cookies) : []
    if (products.indexOf(MinimogSettings.productHandle) === -1) {
      products.unshift(MinimogSettings.productHandle)
      products = products.slice(0, 20)
      setCookie('m-recent-viewed-products', JSON.stringify(products));
    }
  }

  loadRebuyAddonsFunct(){
    document.addEventListener('rebuy.ready', (event) => {
      window.rebuyAddOns = event.detail.widget.data.products || null;
      /* console.log('rebuyAddOns:',window.rebuyAddOns); */
      
      this.getFullStationPrice();

      setTimeout(()=>{
        this.calculateTotalPrice();

        let rebuyAddonItems = document.querySelectorAll(".rebuy-addon__items .rebuy-addon__item");
        rebuyAddonItems.forEach((item, index)=>{
          let checkbox = item.querySelector("input.checkbox-input.rebuy-checkbox");
          if( window.rebuyAddOns[index].title != "Assembled" && window.rebuyAddOns[index].id != 8848941547685 ){
            checkbox.click();
          }else{
            item.classList.add("assembled-addon-item");
            this.injectHTML(index);
            if(document.querySelector('input#assembled-checkbox')){
              document.querySelector('input#assembled-checkbox').addEventListener('click', () => {
                checkbox.click();
              });
            }
          }
        });

        if (document.querySelector('span.prod_regg')) {
          document.querySelector('.template-product input.m-quantity__input.form-field').addEventListener('change',()=>{
            setTimeout(()=>{
              this.updateRegPrice();
              this.updateTotalPrice();
            },300);
          });
        }

        if (window.rebuyAddOns.length>0) {
          document.body.classList.add('with-rebuy-addons');
        }
      },500);
    });
  }

  getFullStationPrice(){
    /* console.log('getFullStationPrice'); */
    let totalPrice = parseFloat(window.product.price.replace(/[$,]/g, ''));

    setTimeout(()=>{
      if (document.querySelector('span.prod_regg')) {
        this.updateRegPrice();
        totalPrice = parseFloat(window.product.price.replace(/[$,]/g, ''));
      }
    },500);

    window.rebuyAddOns.filter((addon, index)=>{
      if ( addon.title != "Assembled" && addon.id != 8848941547685 ) {
        totalPrice += parseFloat(addon.selected_variant.price);
      }
    });

    totalPrice = totalPrice.toFixed(2);
    document.querySelector(".rebuy-total-price .full-station").textContent = Shopify.formatMoney(totalPrice);
  }

  calculateTotalPrice(){
    /* console.log('calculateTotalPrice'); */
    document.querySelectorAll("input.checkbox-input.rebuy-checkbox").forEach((input, index)=>{
      input.addEventListener("change", ()=>{
        this.updateTotalPrice();
        if( window.rebuyAddOns[index].title == "Assembled" && window.rebuyAddOns[index].id == 8848941547685 ){
          var assembled = document.querySelector(".rebuy-addon__item:nth-child("+(index+1)+"n)");
          if (window.rebuyAddOns[index].selected) {
            // Create a new element
            const assembled_info = document.createElement('div');
            assembled_info.classList.add('assembled-info');
            assembled_info.textContent = 'Assembled workstations only have oversize extra shipping fee.';
            // Append to a parent element
            assembled.querySelector('.rebuy-addon__item-info').appendChild(assembled_info);
          }else{
            assembled.querySelector('.assembled-info').remove();
          }
        }
      });
    });
  }

  updateRegPrice(){
    window.product.price = document.querySelector('span.prod_regg').innerText;
    document.querySelector('.rebuy-total-price.static-price .head-only').innerText = window.product.price;
  }

  updateTotalPrice(){
    let totalPrice = parseFloat(window.product.price.replace(/[$,]/g, ''));

    window.rebuyAddOns.filter((addon)=>{
      if (addon.selected) {
        totalPrice += parseFloat(addon.selected_variant.price);
      }
    });

    totalPrice = totalPrice.toFixed(2);
    document.querySelector(".rebuy-total-price .total-price").textContent = Shopify.formatMoney(totalPrice);
  }

  injectHTML(index){
    // Create the main container for the assembled addon
    const assembledAddon = document.createElement('div');
    assembledAddon.className = 'assembled-addon';

    // Create the table element
    const table = document.createElement('table');
    table.className = 'table-addon';

    // Create the table body
    const tbody = document.createElement('tbody');

    // Create the first row for the "RECOMMENDED OPTION" heading
    const headingRow = document.createElement('tr');
    const headingCell = document.createElement('td');
    headingCell.colSpan = 3;
    const heading = document.createElement('h4');
    heading.textContent = 'RECOMMENDED OPTION';
    headingCell.appendChild(heading);
    headingRow.appendChild(headingCell);

    // Create the second row for the addon details
    const addonRow = document.createElement('tr');
    addonRow.className = 'addon-row';

    // Create the checkbox cell
    const checkboxCell = document.createElement('td');
    checkboxCell.className = 'addon-checkbox';
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'assembled-checkbox';
    checkbox.className = 'checkbox-input rebuy-checkbox';
    checkboxCell.appendChild(checkbox);

    // Create the info cell
    const infoCell = document.createElement('td');
    infoCell.className = 'addon-info';
    const addonTitle = document.createElement('p');
    addonTitle.className = 'addon-title';
    addonTitle.textContent = 'Prizzi Assembly Service';
    const addonDesc1 = document.createElement('p');
    addonDesc1.className = 'addon-desc';
    addonDesc1.textContent = 'With this option, you receive the machine ready to use. No hassle, no handymen.';
    const addonDesc2 = document.createElement('p');
    addonDesc2.className = 'addon-desc';
    addonDesc2.textContent = 'Assembled workstations only have oversize extra shipping fee.';
    infoCell.appendChild(addonTitle);
    infoCell.appendChild(addonDesc1);
    infoCell.appendChild(addonDesc2);

    // Create the price cell
    const priceCell = document.createElement('td');
    priceCell.className = 'addon-price';
    const addonPrice = document.createElement('span');
    addonPrice.id = 'product-addon-price';
    addonPrice.setAttribute('data-addon-price', window.rebuyAddOns[index].selected_variant.price);
    addonPrice.textContent = '$' + window.rebuyAddOns[index].selected_variant.price;
    priceCell.appendChild(addonPrice);

    // Append all cells to the addon row
    addonRow.appendChild(checkboxCell);
    addonRow.appendChild(infoCell);
    addonRow.appendChild(priceCell);

    // Append the rows to the table body
    tbody.appendChild(headingRow);
    tbody.appendChild(addonRow);

    // Append the table body to the table
    table.appendChild(tbody);

    // Append the table to the assembled addon container
    assembledAddon.appendChild(table);

    // Find the div with the class 'rebuy-addon__items' and inject the assembled addon
    const targetDiv = document.querySelector('.rebuy-addon__items');
    if (targetDiv) {
        targetDiv.appendChild(assembledAddon);
    } else {
        console.error('Div with class "rebuy-addon__items" not found.');
    }
  }
}

window.UpdateCart = {
  drawer: ()=>{
    var cartDrawrer = document.querySelector('#MinimogCartDrawer')
    var cartDrawerInner = document.querySelector(".m-cart-drawer__inner");

    fetch(`/cart/?section_id=cart-drawer`)
    .then((data) => data.text())
    .then((dataText) => {
        const html = new DOMParser().parseFromString(dataText, "text/html");
        document.querySelector("[data-minimog-cart-items]").innerHTML = html.querySelector("[data-minimog-cart-items]").innerHTML;
        document.querySelector("#MinimogCartDrawerFooter").innerHTML = html.querySelector("#MinimogCartDrawerFooter").innerHTML;
        cartDrawrer.classList.remove('m-cart--empty');
        cartDrawrer.classList.add("m-cart-drawer--active");
        requestAnimationFrame(() => {
            document.querySelector('#MinimogCartDrawer').style.setProperty("--m-bg-opacity", "0.5");
            cartDrawerInner.style.setProperty("--translate-x", "0");
        });
        window.MinimogTheme.Notification.show({
          target: cartDrawrer.querySelector("m-cart-drawer-items"), method: "prepend", type: "success",
          message: 'Added item(s)', delay: 400,
        });
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
        fetchJSON(window.Shopify.routes.root + "cart.json").then((cart) => {
          if (cart) {
            const count = cart.item_count;
            const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
            cartCounts.forEach((cartCount) => {
              if (count > 0) {
                cartCount.textContent = count;
                cartCount.classList.remove("m:hidden");
              } else {
                cartCount.classList.add("m:hidden");
              }
            });
          }
        });
    })
    .catch((e) => {console.error(e);})
    .finally(() => {
        const cartPage = document.querySelector("m-cart");
    
        if (cartDrawrer) {
            const cartDrawerItems = cartDrawrer.querySelector("m-cart-drawer-items");
            if (cartDrawrer.classList.contains("m-cart--empty")) cartDrawrer.classList.remove("m-cart--empty");
            if (cartDrawerItems && cartDrawerItems.classList.contains("m-cart--empty")) cartDrawerItems.classList.remove("m-cart--empty");
        }
        if (cartPage) {
            if (cartPage.classList.contains("m-cart--empty")) cartPage.classList.remove("m-cart--empty");
        }
    });
  }
};